import { get, ref, set, remove } from "firebase/database";
import { database } from "../Firebase";
import { songs } from "./songs.example";

export async function uploadSongs() {
  //user 0
  const dbRef = ref(database, "/songs");
  set(dbRef, songs);
}

export async function downloadSongs() {
  const dbRef = ref(database, "/songs");
  return (await get(dbRef)).val();
}

// Create : set
// Read : get
// Update
// Delete

//CRUD

// function uploadScores () {
//     const dbRef = ref(database, "/scores");
//     set(dbRef, {
//         team: "team1",
//         score: 100,
//         list: [1,234],
//         obejct: {}
//     })
// }
// function update() {
//     const dbRef = ref(database, "/scores");
//     update(dbRef, {score: 200})
// }
// // uploadScores()
// readScore()
// geScore()

// function firebaseDelete() {
//     const dbRef = ref(database, "/scores");
//     remove(dbRef)
// }
